export default __webpack_public_path__ + "static/media/mini-9.d0491061.jpg";